export default __webpack_public_path__ + "static/media/questions.03aed1a4.webp";